export const RELATIVE_PATH = {
  search: '/workflow/marketing-templates/search',
  marketingTemplates: '/workflow/marketing-templates',
  dashboard: '/dashboard',
  newUserOnboarding: '/new-user',
  studioRedirect: '/redirect',
};
